/* unplugin-vue-components disabled */import script from "./KLineTrendView.vue?vue&type=script&setup=true&lang=js"
export * from "./KLineTrendView.vue?vue&type=script&setup=true&lang=js"

import "./KLineTrendView.vue?vue&type=style&index=0&id=7d2b22c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2b22c7"]])

export default __exports__